import { Button } from "@common/components/ui/button"
import { useHasPermission } from "@common/hooks/use-permissions"
import { createFileRoute, Link } from "@tanstack/react-router"
import { TaskListPage } from "../-components/task-list-page"
import { prefetchTasks } from "../-components/task-table"
import { taskFilterSchema, taskGroupings } from "../-lib/filters"

export const Route = createFileRoute("/_layout/templates/tasks")({
  staticData: { breadcrumb: "Template tasks" },
  validateSearch: (search) => taskFilterSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) =>
    prefetchTasks(queryClient, deps, null, taskGroupings(null, false)),
  component: TemplateTasksPage,
})

function TemplateTasksPage(): React.ReactElement {
  const filters = Route.useSearch()
  const canCreate = useHasPermission("canned_work_package:create")

  return (
    <TaskListPage
      name="Template tasks"
      filters={filters}
      packageId={null}
      onOverview={null}
      actions={
        canCreate && (
          <Button asChild size="sm">
            <Link to="/templates/tasks/create" search={true}>
              New template task
            </Link>
          </Button>
        )
      }
    />
  )
}
